<template>
  <nav class="navbar call-centre navbar-expand-lg fixed-top bg-white" id="main-navbar">
    <router-link class="navbar-brand mr-auto mr-lg-0" to="/" v-on:click.native="menuClick">
      <img src="/assets/images/logo/my-logo.svg" width="200" alt="me&you Mobile Logo" />
    </router-link>

    <button
      class="hamburger hamburger--collapse navbar-toggler border-0"
      type="button"
      data-toggle="offcanvas"
      v-on:click="showMobileMenu = !showMobileMenu"
      v-bind:class="{ 'is-active': showMobileMenu }"
    >
      <span class="hamburger-box">
        <span class="hamburger-inner"></span>
      </span>
    </button>

    <div class="call-centre navbar-collapse offcanvas-collapse" v-bind:class="{ open: showMobileMenu }">
      <div class="navbar-collapse-inner">
        <ul class="navbar-nav mr-auto">
          <li class="nav-item"></li>
        </ul>
        <ul class="navbar-nav align-items-center justify-content-end">
          <li class="nav-item">
            <router-link class="nav-link" to="/mobile/hot-deals" v-on:click.native="menuClick">Mobile</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/fixed-lte/signup" v-on:click.native="menuClick">Fixed LTE</router-link>
          </li>          
          <li class="nav-item nav-cart">
            <router-link class="nav-link" to="/checkout" v-on:click.native="menuClick">
              <i class="fa fa-shopping-cart"></i>
              <span
                class="badge badge-pill badge-dark d-none d-lg-inline"
                v-if="cartCount > 0"
              >{{ cartCount }}</span>
              <span class="pl-2 d-lg-none">Cart</span>
            </router-link>
          </li>          
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "site-navigation-call-centre",  
  computed: {
    ...mapGetters(["cartSims"])
  },
  data: function() {
    return {
      cartCount: 0,
      showMobileMenu: false,            
      is_working: false
    };
  },
  methods: {
    menuClick(event) {
      var self = this;
      self.$emit("navigation-menu-click", { event: event });
      self.showMobileMenu = false;
      self.showLoginForm = false;
    }
  },
  watch: {
    cartSims: function(newValue) {
      var self = this;
      self.$log.debug("CART SIMs", newValue);
      self.cartCount = newValue.length;
    }
  },
  mounted() {
    var self = this;
    self.cartCount = self.cartSims.length;
  }
};
</script>


